import { Divider, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { HealthFields } from 'src/non-financial-data/v2/sections/fields/HealthFields';
import { VulnerabilityFields } from 'src/non-financial-data/v2/sections/fields/VulnerabilityFields';
import IndividualEntityForm from '../IndividualEntityForm';

function SubsectionHeading({ children }: { children: string }) {
  return (
    <Text size="lg" fw={FONT_WEIGHTS.semibold} c="gray.10">
      {children}
    </Text>
  );
}

export default function HealthAndVulnerabilitiesV2() {
  return (
    <IndividualEntityForm title="Health & vulnerabilities">
      <SubsectionHeading>Health</SubsectionHeading>
      <HealthFields />

      <Divider />

      <SubsectionHeading>Vulnerabilities</SubsectionHeading>
      <VulnerabilityFields />
    </IndividualEntityForm>
  );
}
